import { useMemo } from "react";
import { useParams } from "react-router-dom";
import BarChart from "src/components/ScoringChart/BarChart";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { useAnalysisSelector } from "src/context/analysisContext";

export default function CreditScoreHistogram() {
  const { holder } = useParams();
  const scoreHistogram = useAnalysisSelector((state) => state.statistic[holder]?.scoreHistogram);

  const { series, category, isLoading } = useMemo(() => {
    if (scoreHistogram) {
      let series = [];
      let category = [];
      const histogramArr = Object.entries(scoreHistogram);
      histogramArr.slice(1).forEach((element, index) => {
        series.push(histogramArr[index][1]);
        category.push(`${histogramArr[index][0]}-${element[0]}`);
      });
      return {
        isLoading: false,
        category: category,
        series: [
          {
            name: "Number Of Wallets",
            data: series,
          },
        ],
      };
    }
    return {
      isLoading: true,
      series: [
        {
          name: "Number Of Wallets",
          data: [],
        },
      ],
      category: [],
    };
  }, [scoreHistogram]);

  return (
    <PaperWrapper
      title="Credit Score Histogram"
      style={{ marginTop: "1.5rem" }}
      paperProps={{ style: { height: 310 } }}
    >
      <BarChart
        isLoading={isLoading}
        categories={category}
        series={series}
        option={{
          chart: {
            height: 290,
          },
          colors: ["#1C8CF3"],
          yAxis: {
            gridLineWidth: 1,
          },
          tooltip: {
            style: {
              display: "block",
            },
          },
        }}
      />
    </PaperWrapper>
  );
}
